import { Component, LOCALE_ID, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AnaliseHoraBi05Service } from '../analise-hora-bi05-service/analise-hora-bi05.service';
import { ConversaoLibraConverte } from '../../../../../shared/conversao-libra/conversao-libra-converte';
import { Filtros } from '../../../../../shared/crud/Filtro/Filtros';
import { ListaBase } from '../../../../../shared/crud/ListaBase';
import { ExportExcelService } from '../../../../../shared/excel-service/export-excel.service';
import { Parametro } from '../../../../../shared/service-base/parametro';

@Component({
  selector: 'app-analise-hora-bi05-lista',
  templateUrl: './analise-hora-bi05-lista.component.html',
  styleUrls: ['./analise-hora-bi05-lista.component.css'],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR'
    }
  ]
})
export class AnaliseHoraBi05ListaComponent extends ListaBase implements OnInit {
  dados_grid: any;
  periodo;
  anoFiltro;
  mesInicial;
  mesFinal;
  subscription;
  
  carregando = false;

  constructor(service: AnaliseHoraBi05Service, toastr: ToastrService, router: Router, private exportExcel: ExportExcelService,
    private translate: TranslateService,
    private conversaoLibraConverte: ConversaoLibraConverte) {
    super(service, toastr, router);
    this.nomeModulo = 'analise-hora-bi05';
  }

  ngOnInit() {
    this.buscar();

    //conversaolibra
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
          this.buscar();
      });
    //fimConversaolibra
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  buscar() {
    this.anoFiltro = this.filtros.ano
    this.filtrarMes();

    let objFiltro: Filtros = new Filtros();
    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        super.incluirItemFiltro(chave, objFiltro);
      }
    }

    this.carregando = true;

    this.service.buscar(objFiltro)
      .then(res => {
        //preco_mo
        res.preco_mo.linhas.forEach(linhas => {
          linhas.mes_01 = this.conversaoLibraConverte.conversaoLibra(linhas.mes_01 ,null,null);
          linhas.mes_02 = this.conversaoLibraConverte.conversaoLibra(linhas.mes_02 ,null,null);
          linhas.mes_03 = this.conversaoLibraConverte.conversaoLibra(linhas.mes_03 ,null,null);
          linhas.mes_04 = this.conversaoLibraConverte.conversaoLibra(linhas.mes_04 ,null,null);
          linhas.mes_05 = this.conversaoLibraConverte.conversaoLibra(linhas.mes_05 ,null,null);
          linhas.mes_06 = this.conversaoLibraConverte.conversaoLibra(linhas.mes_06 ,null,null);
          linhas.mes_07 = this.conversaoLibraConverte.conversaoLibra(linhas.mes_07 ,null,null);
          linhas.mes_08 = this.conversaoLibraConverte.conversaoLibra(linhas.mes_08 ,null,null);
          linhas.mes_09 = this.conversaoLibraConverte.conversaoLibra(linhas.mes_09 ,null,null);
          linhas.mes_10 = this.conversaoLibraConverte.conversaoLibra(linhas.mes_10 ,null,null);
          linhas.mes_11 = this.conversaoLibraConverte.conversaoLibra(linhas.mes_11 ,null,null);
          linhas.mes_12 = this.conversaoLibraConverte.conversaoLibra(linhas.mes_12 ,null,null);
          linhas.total_ano = this.conversaoLibraConverte.conversaoLibra(linhas.total_ano ,null,null);
          linhas.total_ano_anterior = this.conversaoLibraConverte.conversaoLibra(linhas.total_ano_anterior ,null,null);
          linhas.total_ano_retrasado = this.conversaoLibraConverte.conversaoLibra(linhas.total_ano_retrasado ,null,null);
        });
        res.preco_mo.total.mes_01 = this.conversaoLibraConverte.conversaoLibra(res.preco_mo.total.mes_01 ,null,null);
        res.preco_mo.total.mes_02 = this.conversaoLibraConverte.conversaoLibra(res.preco_mo.total.mes_02 ,null,null);
        res.preco_mo.total.mes_03 = this.conversaoLibraConverte.conversaoLibra(res.preco_mo.total.mes_03 ,null,null);
        res.preco_mo.total.mes_04 = this.conversaoLibraConverte.conversaoLibra(res.preco_mo.total.mes_04 ,null,null);
        res.preco_mo.total.mes_05 = this.conversaoLibraConverte.conversaoLibra(res.preco_mo.total.mes_05 ,null,null);
        res.preco_mo.total.mes_06 = this.conversaoLibraConverte.conversaoLibra(res.preco_mo.total.mes_06 ,null,null);
        res.preco_mo.total.mes_07 = this.conversaoLibraConverte.conversaoLibra(res.preco_mo.total.mes_07 ,null,null);
        res.preco_mo.total.mes_08 = this.conversaoLibraConverte.conversaoLibra(res.preco_mo.total.mes_08 ,null,null);
        res.preco_mo.total.mes_09 = this.conversaoLibraConverte.conversaoLibra(res.preco_mo.total.mes_09 ,null,null);
        res.preco_mo.total.mes_10 = this.conversaoLibraConverte.conversaoLibra(res.preco_mo.total.mes_10 ,null,null);
        res.preco_mo.total.mes_11 = this.conversaoLibraConverte.conversaoLibra(res.preco_mo.total.mes_11 ,null,null);
        res.preco_mo.total.mes_12 = this.conversaoLibraConverte.conversaoLibra(res.preco_mo.total.mes_12 ,null,null);
        res.preco_mo.total.total_ano = this.conversaoLibraConverte.conversaoLibra(res.preco_mo.total.total_ano ,null,null);
        res.preco_mo.total.total_ano_anterior = this.conversaoLibraConverte.conversaoLibra(res.preco_mo.total.total_ano_anterior ,null,null);
        res.preco_mo.total.total_ano_retrasado = this.conversaoLibraConverte.conversaoLibra(res.preco_mo.total.total_ano_retrasado ,null,null);
        
        this.dados_grid = res;
        
        this.carregando = false;
      });
  }

  protected filtrarMes() {

    if (parseFloat(this.filtros.mes_inicial) > parseFloat(this.filtros.mes_final)) {
      this.toastr.error('Filtro não permitido');
      this.filtros.mes_inicial = 1;
      this.filtros.mes_final = 12;
    } else {
      this.mesInicial = this.filtros.mes_inicial;
      this.mesFinal = this.filtros.mes_final;
    }  
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.mercado
      || this.filtros.grupo_economico
      || this.filtros.regiao
      || this.filtros.regional
      || this.filtros.dealer
      || this.filtros.ano
      || this.filtros.mes_inicial
      || this.filtros.mes_final
  }

  carregar() {
    const objFiltro = new Filtros();

    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        objFiltro.filtros.push(new Parametro(chave, this.filtros[chave]));
      }
    }
  }

  exportarExcel() {
    this.exportExcel.nomeModulo = this.nomeModulo;
    this.exportExcel.ExportTOExcel();
  }

}
